
import { HttpResponse, defaultHttpResponse } from '../auth/AuthInterface';

import { PaginacionProps } from '../global/PaginacionInterface';

import { DependenciaProps } from '../catalogos/DependenciaInterface';
import { AmparoProps, defaultAmparo } from '../recepcion/AmparoInterface';
import { defaultIrregular, IrregularProps } from '../recepcion/IrregularInterface';
import { defaultExpediente, ExpedienteProps } from '../recepcion/ExpedienteInterface';
import { defaultExhortoRecibido, ExhortoRecibidoProps } from '../recepcion/ExhortoRecibidoInterface';

// Definición de defaults

export const defaultOficio: OficioProps = {
    idOficio: 0,
    idEstatus: 0,
    numeroOficio: '',
    juez: '',
    firmaJuez: false,
    idPlantilla: 0,
    plantilla: '',
    contenido: '',
    documento: '',
    idTipoOficio: 0,
    tipoOficio: '',   
    idSubTipoAcuerdo: 0,
    subTipoAcuerdo: '',
    observaciones: [],
    asignadoMismoUsuario: false,
    usuarioAsignado: '',
    idExpediente: 0,
    expediente: defaultExpediente,
    idIrregular: 0,
    irregular: defaultIrregular,
    idAmparo: 0,
    amparo: defaultAmparo,
    idExhortoRecibido: 0,
    exhortoRecibido: defaultExhortoRecibido,
    idDependencia: 0,
    destinatarios: [],
};

export const defaultNuevoOficio: NuevoOficioResponse = {
    ...defaultHttpResponse,
    idOficio: '',
};

export const defaultDetalleOficio: DetalleOficioResponse = {
    ...defaultHttpResponse,
    ...defaultOficio,
};

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    asignadoMismoUsuario: false,
    usuarioAsignado: '',
};

export const defaultConsultaOficios: ConsultaOficiosResponse = {
    currentPageIndex: 0,
    pageCount: 0,
    recordsCount: 0,
    records: [],
};

// Creación de interfaces

export interface NuevoOficioParams {
    idTipoOficio:       number;
    idExpediente:       number;
    idExhortoRecibido:  number;
    idIrregular:        number;
    idAmparo:           number;
}

export interface NuevoOficioResponse extends HttpResponse {
    idOficio:       string;
}

export interface OficioProps {
    idOficio:               number;
    idEstatus:              number;
    numeroOficio:           string;
    juez:                   string;
    firmaJuez:              boolean;
    idPlantilla:            number;
    plantilla:              string;
    contenido:              string;
    documento:              string;
    idTipoOficio:           number;
    tipoOficio:             string;
    idSubTipoAcuerdo:       number;
    subTipoAcuerdo:         string;
    observaciones:          UsuarioObservacionesProps[];
    asignadoMismoUsuario:   boolean;
    usuarioAsignado:        string;
    idExpediente:           number;
    expediente:             ExpedienteProps;
    idIrregular:            number;
    irregular:              IrregularProps;
    idAmparo:               number;
    amparo:                 AmparoProps;
    idExhortoRecibido:      number;
    exhortoRecibido:        ExhortoRecibidoProps;
    idDependencia:          number;
    dependencia?:           DependenciaProps;
    destinatarios:          DestinatarioProps[];
    fecha?:                 Date;
}

export interface DetalleOficioResponse extends HttpResponse, OficioProps { }

export interface ActualizarOficioParams {
    idOficio:           string;
    contenido:          string;
    idPlantilla:        number;
    idSubtipoAcuerdo:   number;
    firmoJuez?:         boolean;
}

export interface ActualizarEstatusParams {
    idOficio:           string;
    idEstatus:          number;
    observaciones:      string;
}

export interface ActualizarEstatusResponse extends HttpResponse {
    asignadoMismoUsuario:   boolean;
    usuarioAsignado:        string;
}

export interface UsuarioObservacionesProps {
    usuario:        string;
    puesto:         string;
    observacion:    string;
    fecha?:         Date;
}

export interface DestinatarioProps {
    idPersona:          number;
    nombreCompleto:     string;
}

export interface GuardarDestinatariosProps {
    idOficio:           string;
    idDependencia:      number;
    destinatarios:      DestinatarioProps[];
}

export interface ConsultaOficiosProps {
    idOficio:                   number;
    numeroSeguimiento:          string;
    numeroOficio:               string;
    referencia:                 string;
    tipoOficio:                 string;
    idEstatus:                  number;
    estatus:                    string;
    usuarioElaboro:             string;
    usuarioAsignado:            string;
    documento:                  string;
    dependencia:                string;
    destinatarios:              DestinatarioProps[];
    fecha?:                     Date;
    expediente:                 ExpedienteProps;
    amparo:                     AmparoProps;
    exhortoRecibido:            ExhortoRecibidoProps;
}

export interface ConsultaOficiosParams extends PaginacionProps {
    fecha:                      string;
    idEstatus:                  number;
    idTipoOficio:               number;
    idAutoridad:                number;
    idMateria:                  number;
    idUsuarioElaboro:           number;
    idUsuarioAsignacion:        number;
}

export interface ConsultaOficiosResponse {
    currentPageIndex:           number;
    pageCount:                  number;
    recordsCount:               number;
    records:                    ConsultaOficiosProps[];
}

export interface DescargarOficiosParams {
    fecha:                     string;
    idEstatus:                 number;
    idTipoOficio:              number;
    idAutoridad:               number;
    idMateria:                 number;
    idUsuarioElaboro:          number;
    idUsuarioAsignacion:       number;
}